module.exports = __webpack_public_path__ + "static/media/some_one_join_room.bfc4cefb.wav";